var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPermissionall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_547",
    "data-name": "Group 547",
    transform: "translate(-4962 -21297)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_255",
    "data-name": "Rectangle 255",
    width: 24,
    height: 24,
    transform: "translate(4962 21297)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_75",
    "data-name": "Union 75",
    d: "M1.965,16.614A6.274,6.274,0,0,1,0,12.079V8.823A2.015,2.015,0,0,1,.447,7.563a2.165,2.165,0,0,1,1.161-.74V4.876A4.84,4.84,0,0,1,4.156.653a5.3,5.3,0,0,1,5.1,0,4.84,4.84,0,0,1,2.549,4.223V6.829h0a2.187,2.187,0,0,1,1.157.737,2,2,0,0,1,.447,1.257v3.256a6.274,6.274,0,0,1-1.964,4.535,6.931,6.931,0,0,1-9.484,0ZM1.6,7.764a1.2,1.2,0,0,0-.5.438,1.128,1.128,0,0,0-.186.621v3.256a5.41,5.41,0,0,0,1.7,3.914,5.984,5.984,0,0,0,8.193,0A5.421,5.421,0,0,0,12.5,12.079l0-3.256a1.155,1.155,0,0,0-.19-.625,1.24,1.24,0,0,0-.5-.435,1.263,1.263,0,0,0-.558-.131H2.162A1.24,1.24,0,0,0,1.6,7.764ZM5.577,4.105a1.454,1.454,0,0,0-.431,1.1V6.759H8.263V5.2a1.44,1.44,0,0,0-.431-1.1,1.609,1.609,0,0,0-2.255,0ZM3.754,2.052A3.919,3.919,0,0,0,2.523,4.876V6.759H4.23V5.2a2.3,2.3,0,0,1,.7-1.726,2.547,2.547,0,0,1,3.561,0A2.3,2.3,0,0,1,9.179,5.2V6.751h1.715V4.876A3.92,3.92,0,0,0,9.663,2.052a4.31,4.31,0,0,0-5.908,0Zm2.612,13.7a.889.889,0,0,1-.647-.25L4.108,13.98a.847.847,0,0,1-.257-.629l.257-.376a20.236,20.236,0,0,0,1.414,1.5,1.67,1.67,0,0,0,.844.446,1.851,1.851,0,0,0,.882-.446l3.222-3.133.1.416a.872.872,0,0,1-.275.629L7.032,15.5a.854.854,0,0,1-.6.261C6.407,15.759,6.388,15.748,6.366,15.748Zm0-1.809a.9.9,0,0,1-.647-.257L4.108,12.172a.866.866,0,0,1-.257-.632.782.782,0,0,1,.257-.606.944.944,0,0,1,1.295,0l.964.9L9,9.322a.972.972,0,0,1,.647-.261,1,1,0,0,1,.647.261.812.812,0,0,1,.275.629.879.879,0,0,1-.275.629l-3.259,3.1a.823.823,0,0,1-.6.261A.345.345,0,0,1,6.366,13.939Z",
    transform: "translate(4967 21300)",
    fill: "#15355c"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissionall);
export default __webpack_public_path__ + "static/media/permissionall.61cf9bef7028868c0be398d8038737cb.svg";
export { ForwardRef as ReactComponent };